import { InputBaseComponentProps, TextField } from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";
import NumberFormat, { NumberFormatValues } from "react-number-format";

function NumberFormatCustom(props: InputBaseComponentProps) {
    const { inputRef, onChange, name, ...other } = props;
    const onValueChange = (values: NumberFormatValues) => {
        if (onChange) {
            // Keeping any as I can't crack the typing issue for this legacy component, and it's working as expected.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (onChange as any)({
                target: {
                    name,
                    value: values.value
                }
            });
        }
    };

    const defaultValue = Array.isArray(props.defaultValue)
        ? props.defaultValue[0]
        : props.defaultValue;

    return (
        <NumberFormat
            {...other}
            defaultValue={defaultValue}
            getInputRef={inputRef}
            onValueChange={onValueChange}
            thousandSeparator={true}
            prefix="$"
            decimalScale={0}
            fixedDecimalScale={true}
        />
    );
}

NumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired
};

interface ICurrencyFieldProps {
    disabled: boolean;
    label: string;
    name: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    required: boolean;
    value: number;
}

export default class CurrencyField extends React.PureComponent<
    ICurrencyFieldProps,
    {}
> {
    public render() {
        return (
            <TextField
                disabled={this.props.disabled}
                required={this.props.required}
                fullWidth={true}
                margin="normal"
                label={this.props.label}
                name={this.props.name}
                value={this.props.value}
                onChange={this.props.onChange}
                InputProps={{ inputComponent: NumberFormatCustom }}
            />
        );
    }
}
